<template>
    <div class="as-footStats" v-if="!isShow">
        <FootballTeam :match="match" :footyStats="footyStats" :fivePreviousMatches="fivePreviousMatches"/>
        <FinalScore :match="match" :footyStats="footyStats"/>
        <Performance :match="match" :footyStats="footyStats" :homeTeamInfo="homeTeamInfo" :awayTeamInfo="awayTeamInfo"/>
        <H2HStatistics :match="match" :footyStats="footyStats"/>
        <GoalsScored :match="match" :footyStats="footyStats" :homeTeamInfo="homeTeamInfo" :awayTeamInfo="awayTeamInfo"/>
        <GoalsScored :match="match" mode="as-loss" :footyStats="footyStats" :homeTeamInfo="homeTeamInfo" :awayTeamInfo="awayTeamInfo"/>
        <GoalsOverUnder :match="match" :footyStats="footyStats" :homeTeamInfo="homeTeamInfo" :awayTeamInfo="awayTeamInfo"/>
        <BothTeamsScore :match="match" :footyStats="footyStats" :homeTeamInfo="homeTeamInfo" :awayTeamInfo="awayTeamInfo"/>
        <TotalCornerKicks :match="match" :footyStats="footyStats" :homeTeamInfo="homeTeamInfo" :awayTeamInfo="awayTeamInfo"/>
        <TeamCornerKick :match="match" :footyStats="footyStats" :homeTeamInfo="homeTeamInfo" :awayTeamInfo="awayTeamInfo"/>
        <WhoWillScore :match="match" :footyStats="footyStats" :homeTeamInfo="homeTeamInfo" :awayTeamInfo="awayTeamInfo"/>
        <WhoWillScore :match="match" mode="as-loss" :footyStats="footyStats" :homeTeamInfo="homeTeamInfo" :awayTeamInfo="awayTeamInfo"/>
        <Card :match="match" :footyStats="footyStats" :homeTeamInfo="homeTeamInfo" :awayTeamInfo="awayTeamInfo"/>
        <WhoIsFirstScoreVue :match="match" :footyStats="footyStats" :homeTeamInfo="homeTeamInfo" :awayTeamInfo="awayTeamInfo"/>
        <PerformanceHalfTime :match="match" :footyStats="footyStats" :homeTeamInfo="homeTeamInfo" :awayTeamInfo="awayTeamInfo"/>
        <TheShotList :match="match" :footyStats="footyStats" :homeTeamInfo="homeTeamInfo" :awayTeamInfo="awayTeamInfo"/>
        <OffsideMiscList :match="match" :footyStats="footyStats" :homeTeamInfo="homeTeamInfo" :awayTeamInfo="awayTeamInfo"/>
        <WhistleList :match="match" :footyStats="footyStats" :homeTeamInfo="homeTeamInfo" :awayTeamInfo="awayTeamInfo"/>
    </div>
    <NoData v-else/>
</template>
<script setup lang="ts">
    import NoData from '../NoData.vue';
    import type { IMatch } from '~src/interfaces';
    import type { IFootyStats, IPreviousMatchId, ITeam } from '~src/interfaces/footystats';
    import FootballTeam from '~src/components/foot_stats/FootballTeam.vue';
    import FinalScore from '~src/components/foot_stats/final_score/FinalScore.vue';
    import Performance from '~src/components/foot_stats/performance/Performance.vue';
    import H2HStatistics from '~src/components/foot_stats/h2h_statistics/H2HStatistics.vue';
    import GoalsScored from '~src/components/foot_stats/goals_scored/GoalsScored.vue';
    import GoalsOverUnder from '~src/components/foot_stats/goals_scored/GoalsOverUnder.vue';
    import BothTeamsScore from '~src/components/foot_stats/goals_scored/BothTeamsScore.vue';
    import TotalCornerKicks from '~src/components/foot_stats/corner/TotalCornerKicks.vue';
    import TeamCornerKick from '~src/components/foot_stats/corner/TeamCornerKick.vue';
    import WhoWillScore from '~src/components/foot_stats/who_will_score/WhoWillScore.vue';
    import Card from '~src/components/foot_stats/screens/Card.vue';
    import WhoIsFirstScoreVue from '~src/components/foot_stats/who_will_score/WhoIsFirstScore.vue';
    import PerformanceHalfTime from '~src/components/foot_stats/performance/PerformanceHalfTime.vue';
    import TheShotList from '~src/components/foot_stats/screens/TheShotList.vue';
    import OffsideMiscList from '~src/components/foot_stats/screens/OffsideMiscList.vue';
    import WhistleList from '~src/components/foot_stats/screens/WhistleList.vue';
    import { computed, onMounted, ref } from 'vue';
    import { getAllTeams, getMatchDetail } from '~src/services/FootystatsService';
    import { isObjectEmpty } from '~src/helpers';

    interface Props {
        match: IMatch;
        footyStats: IFootyStats
    }

    const props = withDefaults(defineProps<Props>(),{
    })

    const homeTeamInfo = ref<ITeam | null>(null);
    const awayTeamInfo = ref<ITeam | null>(null);
    const fivePreviousMatches = ref<IPreviousMatchId[] | []>([]);

    onMounted(() => {
        if (props.footyStats) {
            homeTeamInfo.value = props.footyStats.home_team_info;
            awayTeamInfo.value = props.footyStats.away_team_info;
            if(props.footyStats?.h2h?.previous_matches_results && props.footyStats?.h2h?.previous_matches_results){
                fivePreviousMatches.value =  props.footyStats.h2h.previous_matches_ids.slice(0, 5);
            }
        }
    });

    const isShow = computed<boolean>(() => {
        return isObjectEmpty(props.footyStats);
    })
</script>

<script lang="ts">
export default {};
</script>
